module.exports = __webpack_public_path__ + "img/conference.adaae95b.jpg";